import styled, { css } from 'styled-components';
import { ReactComponent as BlackLinesSVG } from 'Public/graphics/clearing/lines-horizontal-short-black.svg';
import { ReactComponent as WhiteLinesSVG } from 'Public/graphics/clearing/lines--horizontal-long-grey.svg';

import Button, { ButtonProps } from 'Campaigns/Clearing/Button';

interface AlignProps {
    $align: 'right' | 'left';
}

interface LinksProps {
    $links: (ButtonProps & { id: string })[];
}

export const Wrapper = styled.div<AlignProps>`
    ${({ $align, theme }) => css`
        display: flex;
        justify-content: center;

        &&&& {
            margin-top: 1rem;
            margin-bottom: 1rem;

            @media ${theme.breakpoints.large.media} {
                margin-bottom: 2.5rem;
            }
        }

        @media ${theme.breakpoints.medium.media} {
            justify-content: ${$align === 'right' ? 'flex-end' : 'flex-start'};
        }
    `}
`;

export const Container = styled.div<AlignProps & LinksProps>`
    ${({ theme, $align, $links }) => css`
        display: flex;
        flex-direction: column;
        position: relative;
        padding: 0 1rem;
        gap: 1.75rem;
        align-items: center;

        @media ${theme.breakpoints.medium.media} {
            align-items: ${$align === 'right' ? 'flex-end' : 'flex-start'};
        }

        ::after {
            content: '';
            position: absolute;
            right: 0;
            ${$align === 'right'
                ? css`
                      right: 0;
                  `
                : css`
                      left: 0;
                  `}
            height: ${$links.length > 1 ? '120%' : '140%'};
            top: ${$links.length > 1 ? '-10%' : '-20%'};
            background: ${theme.colors.secondary.tints[1].hex};
            width: 50%;
            z-index: -1;
        }
    `}
`;

export const ButtonWrapper = styled.div`
    display: inline-block;
    position: relative;
`;

export const BlackLines = styled(BlackLinesSVG)<AlignProps>`
    ${({ theme, $align }) => css`
        position: absolute;
        width: 2rem;
        height: 1rem;
        z-index: 1;
        top: -0.5rem;
        ${$align === 'right'
            ? css`
                  right: 1.5rem;
              `
            : css`
                  left: 1.5rem;
              `}

        @media ${theme.breakpoints.medium.media} {
            width: 3rem;
            height: 1.5rem;
        }
    `}
`;

export const WhiteLines = styled(WhiteLinesSVG)<AlignProps>`
    ${({ theme, $align }) => css`
        position: absolute;
        z-index: 1;
        bottom: -0.5rem;
        ${$align === 'right'
            ? css`
                  left: 1rem;
              `
            : css`
                  right: 1rem;
              `}
        width: 5.5rem;
        height: 1rem;

        @media ${theme.breakpoints.medium.media} {
            bottom: -0.75rem;
            width: 8.25rem;
            height: 1.5rem;
        }
    `}
`;

export const StyledLink = styled(Button)<AlignProps>`
    ${({ theme, $align }) => css`
        padding: 1rem 2rem;
        margin-right: 0;

        /*stops 100% percent width*/
        align-self: ${$align === 'right' ? 'flex-end' : 'flex-start'};

        @media ${theme.breakpoints.medium.media} {
            padding: 1.25rem 5rem;
        }
    `}
`;
